import { useEffect, useState } from "react";

const useSaveValidation = (period, title) => {
	const [saveValidationSuccess, setSaveValidationSuccess] = useState(false);
	const [saveValidationErrors, setSaveValidationErrors] = useState("");

	useEffect(() => {
		const errors = [];
		const errorTitle = "Нельзя сохранить опрос: ";
		if (!period?.length) {
			errors.push("период не выбран");
		}
		if (!title?.length) {
			errors.push("заголовок не указан");
		}
		setSaveValidationSuccess(!errors.length);
		if (errors.length) {
			setSaveValidationErrors(errorTitle + errors.join(", ") + ".");
		} else {
			setSaveValidationErrors("");
		}
	}, [period?.length, title?.length]);
	return [saveValidationSuccess, saveValidationErrors];
};

export default useSaveValidation;
